import React from 'react';
import * as ToggleGroup from '@radix-ui/react-toggle-group';

import { bemBlock } from '../../modules/bem';
import { LayoutRow, LayoutRowProps } from '../layout-row/LayoutRow';

import { ToggleSwitchButton } from './ToggleSwitchButton';

import './ToggleSwitch.less';

const block = bemBlock('n-toggle-switch');

type ToggleSwitchRootProps = {
  type: 'single';
  value: string;
  disabled?: boolean;
  onValueChange: (value: string) => void;
};

type ToggleSwitchProps = LayoutRowProps<{
  selected: string;
  disabled?: boolean;
  onValueChange?: (value: string) => void;
}>;

function ToggleSwitchRaw({
  className,
  children,
  selected,
  disabled,
  onValueChange,
  ...rest
}: ToggleSwitchProps) {
  const handleValueChange = React.useCallback(
    (value: string) => {
      if (!value || value === selected) {
        return;
      }

      onValueChange?.(value);
    },
    [onValueChange, selected],
  );

  return (
    <LayoutRow<ToggleSwitchRootProps>
      component={ToggleGroup.Root}
      type="single"
      value={selected}
      onValueChange={handleValueChange}
      disabled={disabled}
      className={block({ extra: className })}
      withPadding="xs"
      spacedChildren="sm"
      span="auto"
      {...rest}
    >
      {children}
    </LayoutRow>
  );
}

export const ToggleSwitch = Object.assign(ToggleSwitchRaw, { Button: ToggleSwitchButton });
